export default __webpack_public_path__ + "static/media/update-task-bundle.17f76691.svg";